module.exports = __webpack_public_path__ + "static/circe-regular-55-534ec7d59fae6ac015a8491928d1f159.otf";